<template>
  <b-modal
    v-model="shown"
    title="Request Documents"
    header-class="bg-purple"
    header-text-variant="white"
    @close="close"
    no-close-on-esc
    no-close-on-backdrop
    centered
    header-bg-variant="primary"
    @ok="createMassDocument"
    @cancel="close"
  >
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="secondary" @click="cancel()">
        Close
      </b-button>
      <b-button variant="primary" @click="ok()">
        Send
      </b-button>
    </template>
    <b-form-group label="Patient">
      <div class="d-flex">
        <vue-toggles
          @click="allActivePatients = !allActivePatients"
          :value="allActivePatients"
          height="20"
          width="30"
          checkedBg="#34C759"
          uncheckedBg="#FF6161"
        />
        <small class="ml-2">All Active Patients</small>
      </div>
    </b-form-group>

    <b-form-group v-if="!allActivePatients">
      <multiple-select
        :options="clientOptionsPicker"
        v-model="massExpressDocument.client"
        :disableFilter="false"
        :onDemand="true"
        :disableCache="true"
        :search="
          (search, loading) => {
            $emit('search', search, loading);
          }
        "
      />
    </b-form-group>
    <b-form-group label="Documents to request">
      <multiple-select
        :options="documentTypesExpress"
        v-model="massExpressDocument.documentType"
        :disableFilter="false"
        :onDemand="true"
        :disableCache="true"
      />
    </b-form-group>
  </b-modal>
</template>
<script>
import { mapActions } from "vuex";
import portalDocumentServer from "../../server/portalDocument";
import MultipleSelect from "../controls/MultipleSelect.vue";

export default {
  name: "MassShareDocuments",
  components: { MultipleSelect },
  props: ["clientOptionsPicker", "documentTypesExpress"],
  emits: ["close"],
  data() {
    return {
      massExpressDocument: {
        client: [],
        documentType: []
      },
      allActivePatients: false
    };
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    close(event) {
      event.preventDefault();
      this.massExpressDocument.client = [];
      this.massExpressDocument.documentType = [];
      this.$emit("close");
    },
    async createMassDocument() {
      var formRequestDocuments = {
        allActivePatients: this.allActivePatients,
        eocIds: this.massExpressDocument.client.map(eoc => eoc.value),
        formIds: this.massExpressDocument.documentType.map(doc => doc.value)
      };
      await portalDocumentServer.massDocumentRequest(formRequestDocuments);
      this.showAlertSuccess();
    }
  },
  computed: {
    shown: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>
<style scoped>
ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  font-size: 14px;
}
</style>
